import React, { Component } from 'react'
import { push, goBack } from 'react-router-redux';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import shortid from 'shortid'
import { parseString } from 'dxf'

import './RotateModal.css';

import Button from '../../components/Button/Button.js'
import CustomField from '../../components/CustomField/CustomField.js'
import Tabs from '../../components/Tabs/Tabs.js'

import { setRotateModalOpen, updateFromRotate, pmUpdateFromHybrid, showTooltip, hideTooltip } from '../../actions/actions.export.js';

class RotateModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      rotate_angle: 0
    }

    this.handleCloseModalCancel = this.handleCloseModalCancel.bind(this);
    this.handleCloseModalSuccess = this.handleCloseModalSuccess.bind(this);
    this.handleRotateChange = this.handleRotateChange.bind(this);
  }

  handleCloseModalCancel(){
    const { dispatch, cacheID, patternManager } = this.props;

    dispatch(updateFromRotate({
      cacheID: cacheID,
      pattern: { rotate_angle: 0 }
    }))

    dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: { rotate_angle: 0 }
    }))
    
    dispatch(setRotateModalOpen(false))
  }



  handleCloseModalSuccess(){
    const { dispatch, cacheID } = this.props;

    dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: { rotate_angle: 0 }
    }))
    
    dispatch(setRotateModalOpen(false))
  }

  handleRotateChange(value){
    const { dispatch, cacheID, change } = this.props;

    if(value > 360) value = 360;
    if(value < -360) value = -360;

    this.setState({
      rotate_angle: value
    })
    
    dispatch(updateFromRotate({
      cacheID: cacheID,
      pattern: { rotate_angle: parseFloat(value) }
    }))
  }

  render(){
    const { dispatch, globalReducer, patternManager, cacheID } = this.props; 
    
    if(!globalReducer.rotateModalOpen) return "";

    var pattern = patternManager.cache[cacheID];

    return <div className="modal theme-light">
      <div className="modal-bg" onClick={this.handleCloseModalCancel}>
      </div>
      <div className="modal-inner">
        <div className="flex-split">
          <span>
            
          </span>
          <span>
          <Button size="squared-normal" color="borderless" display={<i className="fal fa-times fa-lg fa-fw"/>} onClick={this.handleCloseModalCancel}/> 
          </span>
        </div>
        {
          pattern.mode !== 'raster' && <p>
            <strong 
              className="pane-link text-warning" 
              >
              Only baked patterns can be rotated.&nbsp;
            </strong> <span
              className="has-tooltip"
              onMouseEnter={(e)=>{ 
                dispatch(showTooltip({
                  e: e,
                  position: 'top', 
                  lag: 100,
                  nobr: false,
                  content: <div style={{width: 200}}>
                    Baking a pattern finalizes the drawing or template data, allowing you to make manual changes to the raw .PAT file.
                  </div>
                }))
              }} 
              onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
              >
              <i className="fal fa-question-circle text-grey-primary"/>
            </span>
          </p>  
        }
        <CustomField
          value={this.state.rotate_angle}
          name="rotate_angle"
          type='number'
          disabled={pattern.mode !== 'raster'}
          placeholder='Rotate angle'
          onChange={this.handleRotateChange}
          description="Rotate all lines in this pattern by an angle 0-360."
          max={360}
          min={-360}
          form={false}
          />
        <br/>
        <div className="list-right">
          <span className="list-item">
            <Button
              display="Cancel"
              color="grey"
              size="medium"
              onClick={this.handleCloseModalCancel}
              />
          </span>
          <span className="list-item">
            <Button
              display="Save"
              color="success"
              size="medium"
              disabled={pattern.mode !== 'raster'}
              onClick={this.handleCloseModalSuccess}
              />
          </span>
        </div>
      </div>
    </div>


    
  }
}

const mapStateToProps = (state) => {
  const { globalReducer, patternManager, user, team } = state;

  return {
    globalReducer, patternManager, user, team
  }
}

export default connect(mapStateToProps)(RotateModal);



// WEBPACK FOOTER //
// ./src/components/RotateModal/RotateModal.js